module.exports = __webpack_public_path__ + "static/media/star-dark.24aff906.svg";